import React, { useEffect, useState } from 'react';
import { Column, Row } from 'react-foundation';
import Modal from '../shared/Modal';
import InfoRow from './InfoRow';
import PriceCard from './/PriceCard';

const index = ({
	products,
	current_subscription,
	subscriptionFeatures,
	scTrialAvailable,
}) => {
	const [byMonth, setByMonth] = useState(true);
	const [isLoadingInvoices, setIsLoadingInvoices] = useState(true);
	const [invoices, setInvoices] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [modalState, setModalState] = useState(false);

	const productOrder = ['Essential', 'Agency', 'Professional'];

	useEffect(() => {
		if (current_subscription.plan_id == null) {
			return;
		}
		// sets byMonth to false if user is subscribed to a yearly subscription
		for (let i = 0; i < productOrder.length; i++) {
			for (let j = 0; j < products[productOrder[i]].plans.length; j++) {
				if (
					products[productOrder[i]].plans[j].interval == 'year' &&
					products[productOrder[i]].plans[j].id ==
						current_subscription.plan_id
				) {
					setByMonth(false);
					return;
				}
			}
		}
	}, []);

	const loadInvoices = async () => {
		const response = await fetch('/api/invoices', {
			method: 'GET',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});
		const { invoices } = await response.json();
		setInvoices(invoices);
		setIsLoadingInvoices(false);
	};

	const cancelSubscription = async (id) => {
		setIsSubmitting(true);
		const response = await fetch(`/api/subscriptions/${id}`, {
			method: 'DELETE',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});
		location.href = '/subscriptions/resolved?cancel';
		setIsSubmitting(false);
	};

	const toggleByMonth = () => {
		setByMonth(!byMonth);
	};

	let subscribedTo = {
		product: null,
		interval: null,
		sub_id: null,
		plan_id: null,
	};
	for (let i = 0; i < productOrder.length; i++) {
		for (let j = 0; j < 2; j++) {
			if (
				products[productOrder[i]].plans[j].id ===
				current_subscription.plan_id
			) {
				subscribedTo.product = products[productOrder[i]].product.name;
				subscribedTo.interval =
					products[productOrder[i]].plans[j].interval;
				subscribedTo.plan_id = current_subscription.plan_id;
				subscribedTo.sub_id = current_subscription.sub_id;
				break;
			}
		}
	}

	return (
		<div className="subscription-page-holder">
			<Row>
				<Column small={12}>
					<div className="title-container">
						<h1>Sponsor Circle subscription plans</h1>
						<div
							className="card-style toggle-container"
							onClick={toggleByMonth}
						>
							<div
								className={
									'toggle-text' + (byMonth ? ' active' : '')
								}
							>
								Monthly
							</div>
							<div className="toggle-button">
								<div
									className={
										'toggle-button-circle' +
										(byMonth ? '' : ' active')
									}
								/>
							</div>
							<div
								className={
									'toggle-text' + (byMonth ? '' : ' active')
								}
							>
								Annually (best value)
							</div>
						</div>
					</div>
				</Column>
			</Row>
			<div className="price-card-container">
				<div className="flex-padding" />
				{productOrder.map((product, index) => {
					const data = products[product];
					let popular = false;

					if (data.product.metadata.kind === 'sc_essential') {
						popular = true;
					}

					return (
						<PriceCard
							product={data}
							byMonth={byMonth}
							popular={popular}
							index={index}
							subscriptionFeatures={subscriptionFeatures}
							key={index}
							subscribedTo={subscribedTo}
							scTrialAvailable={scTrialAvailable}
							turnOnModal={() => {
								setModalState(true);
							}}
						/>
					);
				})}
			</div>
			<Modal
				cta={true}
				title="Are you sure you would like to Unsubscribe?"
				text="You will be losing access to premium services"
				modalState={modalState}
				turnOffModal={() => {
					setModalState(false);
				}}
				buttonFunction={() =>
					cancelSubscription(current_subscription.sub_id)
				}
			/>

			<div className="check-list-container">
				{subscriptionFeatures.map((feature, index) => {
					if (index === 0) {
						return (
							<InfoRow
								feature={feature}
								bold={true}
								key={index}
							/>
						);
					}
					return (
						<InfoRow feature={feature} bold={false} key={index} />
					);
				})}
			</div>
		</div>
	);
};

export default index;
